<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      default_layout:'header-footer',
    }
  },
  mounted(){ 
    // console.log(this.$route,this.default_layout)
  },
  computed:{
    layout(){
      return this.$route.meta.layout
    }
  },
}
</script>

<style>
#app {
  font-family: 'PingFangSC-Regular, sans-serif';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
body{
  margin: 0 !important;
   font-family: 'Microsoft YaHei';
   min-width: 1262px;
   box-sizing: border-box;
   overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue